import datetimepickerLibPlugin from "./datetimepicker";

export default {
    datetimepickerLibPlugin
};
